import { AlertCircle } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface ErrorBannerProps {
  /** Heading line. Defaults to "Something went wrong". */
  title?: ReactNode;
  /** Optional secondary message — typically the underlying error.message. */
  message?: ReactNode;
  className?: string;
}

/**
 * Compact red strip used to surface query/mutation failures inside a page or
 * form. Pair with TanStack Query's `error.message` for the message slot.
 */
export function ErrorBanner({
  title = 'Something went wrong',
  message,
  className,
}: ErrorBannerProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700',
        className,
      )}
    >
      <AlertCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-red-500" />
      <div className="min-w-0">
        <div className="font-medium">{title}</div>
        {message && <div className="mt-0.5 text-xs text-red-600">{message}</div>}
      </div>
    </div>
  );
}
